export const Dots = require("./data/library/custom/Animated/Dots").default;
export const Oval = require("./data/library/custom/Animated/Oval").default;
export const Pulse = require("./data/library/custom/Animated/Pulse").default;
